import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=bd58d604&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=bd58d604&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd58d604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd58d604')) {
      api.createRecord('bd58d604', component.options)
    } else {
      api.reload('bd58d604', component.options)
    }
    module.hot.accept("./ItemDetail.vue?vue&type=template&id=bd58d604&scoped=true", function () {
      api.rerender('bd58d604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ItemDetail.vue"
export default component.exports